import { api } from "./customers"

export interface RoleManagement {
    id: number
    roleName: string
    activeStatus: number
}

type RoleManagementResponse = RoleManagement[]
export interface RoleManagementsResponse {
    status: boolean;
    message: string;
    total_count: number;
    total_pages: number;
    current_page: number;
    prev_page: number;
    next_page: number;
    data: RoleManagement[];
}


export const RoleManagementApi = api.injectEndpoints({
    endpoints: (build) => ({
        getRoleManagementsMaster: build.query<RoleManagementsResponse, any>({
            query: () => 'roles_master_list',
           
        }),
        getRoleManagements: build.query<RoleManagementsResponse, any>({
            query: ({pageNo}) => `roles_master?page=${pageNo}`,
            // transformResponse: (response: { data: RoleManagementsResponse }, meta, arg) => response.data,
            // providesTags: (result) =>
            //     result
            //         ? [
            //             ...result.map(({ id }) => ({ type: 'RoleManagement' as const, id })),
            //             { type: 'RoleManagement', id: 'LIST' },
            //         ]
            //         : [{ type: 'RoleManagement', id: 'LIST' }],
        }),
        getAllRoles: build.query<any,any>({
            query: () =>
                `Roles_active`,
          }),     
        addRoleManagement: build.mutation<RoleManagement, Partial<RoleManagement>>({
            query: (body) => ({
                url: `roles_master`,
                method: 'POST',
                body,
            }),
            transformResponse: (response: { data: RoleManagement }, meta, arg) => response.data,
            invalidatesTags: [{ type: 'RoleManagement', id: 'LIST' }],
        }),
        getRoleManagement: build.query<RoleManagement, string>({
            query: (id) => `roles_master/${id}`,
            transformResponse: (response: { data: RoleManagement }, meta, arg) => response.data,
        }),
        updateRoleManagement: build.mutation<void, Pick<RoleManagement, 'id'> & Partial<RoleManagement>>({
            query: ({ id, ...patch }) => ({
                url: `roles_master/${id}`,
                method: 'PUT',
                body: patch,
            }),
            invalidatesTags: [{ type: 'RoleManagement', id: 'LIST' }],
        }),
        deleteRoleManagement: build.mutation<{ success: boolean; id: number }, number>({
            query(id) {
                return {
                    url: `roles_master/${id}`,
                    method: 'DELETE',
                    body:{activeStatus:2}
                }
            },
            invalidatesTags: [{ type: 'RoleManagement', id: 'LIST' }],
        }),
    }),
})

export const {
    useGetRoleManagementsMasterQuery,
    useGetRoleManagementQuery,
    useGetRoleManagementsQuery,
    useAddRoleManagementMutation,
    useUpdateRoleManagementMutation,
    useDeleteRoleManagementMutation,
    useGetAllRolesQuery
} = RoleManagementApi

